import React, { PureComponent } from 'react'
import history from 'configureHistory'
import { translate } from 'react-polyglot'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { PageOverlay, Tabs } from 'components'

import ProfilePage from 'scenes/Profile'
import TeamPage from 'scenes/Team'
import MembersPage from 'scenes/Members'
import AchievementsPage from 'scenes/Achievements'
// import GroupsPage from 'scenes/Groups'
// import AccessPage from 'scenes/Access'
// import BillingPage from 'scenes/Billing'

class SettingsPage extends PureComponent {
	render() {
		const { tab, location, auth, t } = this.props
		const tabs = [
			{
				title: t('settings.profile_tab'),
				link: '#settings-profile',
				component: <ProfilePage />,
			},
			{
				title: t('settings.team_tab'),
				link: '#settings-team',
				component: <TeamPage />,
				requiredRole: 300,
				children: ['#settings-create-team'],
			},
			{
				title: t('settings.users_tab'),
				link: '#settings-members',
				component: <MembersPage />,
				requiredRole: 300,
				children: ['#settings-invite'],
			},
			{
				title: t('settings.invite_users'),
				link: '#settings-invite',
				component: <MembersPage openInvites />,
				requiredRole: 300,
				isHidden: true,
			},
			{
				title: t('settings.create_team'),
				link: '#settings-create-team',
				component: <TeamPage openCreateTeam />,
				requiredRole: 300,
				isHidden: true,
			},
			{
				title: t('settings.achievements_tab'),
				link: '#settings-achievements',
				component: <AchievementsPage />,
			},
			// {
			// 	title: t('settings.groups_tab'),
			// 	link: '#settings-groups',
			// 	component: <GroupsPage />,
			// 	requiredRole: 300,
			// },
			// {
			// 	title: t('settings.access_tab'),
			// 	link: '#settings-access',
			// 	component: <AccessPage />,
			// 	requiredRole: 300,
			// },
			// {
			// 	title: t('settings.billing_tab'),
			// 	link: '#settings-billing',
			// 	component: <BillingPage />,
			// 	requiredRole: 200,
			// },
		]

		if (
			tabs.filter(cTab => cTab.link === `#settings-${tab}`).length === 0
		) {
			return null
		}

		return (
			<PageOverlay
				location={location}
				contentWidth="wide"
				header={
					<Tabs
						items={tabs
							.filter(
								t =>
									(!t.requiredRole ||
										t.requiredRole <= auth.role) &&
									!t.isHidden
							)
							.map(cTab => cTab.title)}
						activeItem={
							tabs.filter(
								cTab =>
									(cTab.children &&
										cTab.children.includes(
											`#settings-${tab}`
										)) ||
									cTab.link === `#settings-${tab}`
							)[0].title
						}
						onClick={title => {
							if (typeof title === 'string') {
								history.push(
									tabs.filter(cTab => cTab.title === title)[0]
										.link
								)
							}
						}}
					/>
				}
			>
				{
					tabs.filter(cTab => cTab.link === `#settings-${tab}`)[0]
						.component
				}
			</PageOverlay>
		)
	}
}

SettingsPage.propTypes = {
	auth: PropTypes.shape().isRequired,
	tab: PropTypes.string.isRequired,
	location: PropTypes.shape().isRequired,
}

const mapStateToProps = state => ({
	auth: state.auth,
})

export default connect(mapStateToProps, null)(translate()(SettingsPage))
